import { useQuery, useQueryClient } from "@tanstack/react-query";

export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public requestId?: string,
    public details?: unknown,
  ) {
    super(message);
  }
}
export type ApiOptions = {
  method?: string;
  body?: unknown;
  signal?: AbortSignal;
};
export async function api<T>(
  path: string,
  options: ApiOptions = {},
): Promise<T> {
  const response = await fetch(`/api/v1${path}`, {
    method: options.method ?? "GET",
    signal: options.signal
      ? AbortSignal.any([options.signal, AbortSignal.timeout(30_000)])
      : AbortSignal.timeout(30_000),
    headers:
      options.body === undefined
        ? { Accept: "application/json" }
        : { Accept: "application/json", "Content-Type": "application/json" },
    body: options.body === undefined ? undefined : JSON.stringify(options.body),
  });
  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new ApiError(
      response.status,
      data?.error?.code ?? "http_error",
      data?.error?.message ?? "请求未能完成，请稍后重试。",
      data?.request_id ?? response.headers.get("x-request-id") ?? undefined,
      data?.error?.details,
    );
  }
  if (response.status === 204) return undefined as T;
  return response.json();
}
export function useApi<T>(path: string | null) {
  return useQuery({
    queryKey: ["api", path],
    queryFn: ({ signal }) => api<T>(path!, { signal }),
    enabled: path !== null,
  });
}
export function useInvalidate() {
  const client = useQueryClient();
  return async () => {
    await client.invalidateQueries({ queryKey: ["api"] });
  };
}
export const expertActor = {
  actor: "web-expert",
  actor_kind: "expert",
} as const;
export function queryString(
  params: Record<string, string | number | boolean | null | undefined>,
) {
  const q = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "")
      q.set(key, String(value));
  });
  return q.toString();
}
